const DAYS_SHORTCUTS = ["so", "mo", "di", "mi", "do", "fr", "sa"];
const DAYS_NAMES = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

function getDayname(lang) {
  const translatedNames = [];
  DAYS_NAMES.forEach((element, index) => {
    const dummyDate = new Date(2001, 0, index);
    translatedNames.push(
      dummyDate.toLocaleDateString(lang, { weekday: "short" })
    );
  });
  return translatedNames;
}

const translation = {
  DE: {
    dayof: "Tag der",
    pickup: "Abholung",
    delivery: "Abgabe",
  },
  EN: {
    dayof: "Day of",
    pickup: "pickup",
    delivery: "return",
  },
};

const langTranslate = (toTranslate, lang) => {
  return translation[lang][toTranslate];
};

export { langTranslate, getDayname, DAYS_SHORTCUTS, DAYS_NAMES };
